import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { IErrors } from '../models/error';

export class HttpService {
    apiUrl: string = '';
    accessToken: string = '';
    private http = inject(HttpClient);

    constructor(apiURL: string) {
        this.apiUrl = apiURL;
    }

    isServerLive() {
        return this.http.get(`${this.apiUrl}/live`, {});
    }

    get(path: string, params: HttpParams | any = new HttpParams()): Observable<any> {

        let p: HttpParams = params;
        if (!(params instanceof HttpParams)) {
            p = new HttpParams();
            for (let key in params) {
                p.append(key, params[key]);
            }
        }
        return this.http.get(`${this.apiUrl}${path}`, { params });

    }

    downloadMedia(fileUrl: string): Observable<Blob> {
        const headers = new HttpHeaders({
            'Accept': 'application/octet-stream'
        });

        return this.http.get(fileUrl, {
            headers,
            responseType: 'blob'
        });
    }


    getRaw(
        path: string,
        responseType: 'arraybuffer' | 'text' | 'blob' | 'json' = 'text',
        headerOptions?: any
    ): Observable<any> {
        return this.http.get(`${this.apiUrl}${path}`, {
            responseType: responseType as any,
            headers: headerOptions,
        });
    }

    uploadFile(path: string, file: File): Observable<any> {
        // Validate file name length
        if (file.name.length > 150) {
            const error: IErrors = {
                Errors: [{
                    Code: 'FILE_NAME_TOO_LONG',
                    Message: 'File name exceeds maximum length of 150 characters',
                    StackTrace: '',
                    InnerErrors: []
                }]
            };
            return throwError(() => error);
        }
        const formData = new FormData();
        formData.append('file', file, file.name);

        const headers = new HttpHeaders({
            'Authorization': `Bearer ${this.accessToken}`,
            'Accept': 'application/json'
        });

        return this.http.post(`${this.apiUrl}${path}`, formData, { headers });
    }


    post(path: string, body: object = {}, headers = {}): Observable<any> {
        return this.http.post(`${this.apiUrl}${path}`, JSON.stringify(body), {
            headers
        });
    }

    postRaw(path: string, body: any, options: object = {}): Observable<any> {
        var headers = new HttpHeaders({
            // "Content-Type": "text/plain",
            "Accept": "text/plain"
        });
        return this.http.post(`${this.apiUrl}${path}`, body, {
            headers: headers
        });
    }

    postPlainText(path: string, body: any, options: object = {}): Observable<any> {
        var headers = new HttpHeaders({
            "Content-Type": "text/plain",
            "Accept": "text/plain"
        });
        return this.http.post(`${this.apiUrl}${path}`, body, {
            headers: headers
        });
    }

    patch(path: string, body: object = {}): Observable<any> {
        return this.http.patch(`${this.apiUrl}${path}`, JSON.stringify(body));
    }

    put(path: string, body: any): Observable<any> {
        return this.http.put(`${this.apiUrl}${path}`, JSON.stringify(body));
    }

    delete(path: string, body?: any): Observable<any> {
        return this.http.delete(`${this.apiUrl}${path}`, {
            body: body ? JSON.stringify(body) : null
        });
    }

    updateAccessToken(accessToken: any) {
        this.accessToken = accessToken;
    }

}
